import React from 'react';
import { observer, inject } from 'mobx-react';
import { AppLocaleProvider, Row, Col } from 'sd-ui-components';
import FormattedDate from '../Common/FormattedDate';
import './EventDetails.less';

const { FormattedMessage } = AppLocaleProvider;

@inject('ConfigStore')
@observer
class EventContent extends React.Component {
  render() {
    const { event } = this.props;

    if (!event) {
      return null;
    }

    return (
      <div>
        <h3>
          <FormattedMessage
            id="App.EventDetails.SafetyDetails"
            defaultMessage="Safety details"
          />
        </h3>
        <Row gutter={6} className="event-details-row">
          <Col span={8} className="event-details-label">
            <FormattedMessage
              id="App.EventDetails.Reviewed"
              defaultMessage="Reviewed"
            />
          </Col>
          <Col span={16} className="event-details-text">
            <FormattedDate
              value={event.reviewDate}
              day="2-digit"
              month="2-digit"
              hour="numeric"
              minute="numeric"
              timeZoneName="short"
              timeZone={this.props.ConfigStore.config.standardizedTimezone}
            />
          </Col>
        </Row>
        <Row className="event-details-row">
          <Col span={8} className="event-details-label">
            <FormattedMessage
              id="App.EventDetails.Observations"
              defaultMessage="Observations"
            />
          </Col>
          <Col span={16} className="event-details-text">
            {event.observations &&
              event.observations.map(observationName => (
                <div key={observationName}>{observationName}</div>
              ))}
          </Col>
        </Row>
        <Row className="event-details-row">
          <Col span={8} className="event-details-label">
            <FormattedMessage
              id="App.EventDetails.Trigger"
              defaultMessage="Trigger"
            />
          </Col>
          <Col span={16} className="event-details-text">
            {event.trigger ? event.trigger.triggerDescription : ''}
          </Col>
        </Row>
        <h3>
          <FormattedMessage
            id="App.EventDetails.DriverDetails"
            defaultMessage="Driver details"
          />
        </h3>
        <Row className="event-details-row">
          <Col span={8} className="event-details-label">
            <FormattedMessage
              id="App.EventDetails.Driver"
              defaultMessage="Driver"
            />
          </Col>
          <Col span={16} className="event-detail-driver-name">
            {event.driver
              ? event.driver.driverFirstName + ' ' + event.driver.driverLastName
              : ''}
          </Col>
        </Row>
        <Row className="event-details-row">
          <Col span={8} className="event-details-label">
            <FormattedMessage
              id="App.EventDetails.Vehicle"
              defaultMessage="Vehicle"
            />
          </Col>
          <Col span={16} className="event-details-text">
            {event.vehicle ? event.vehicle.vehicleSerialNumber : ''}
          </Col>
        </Row>
        <Row className="event-details-row">
          <Col span={8} className="event-details-label">
            <FormattedMessage
              id="App.EventDetails.Site"
              defaultMessage="Site"
            />
          </Col>
          <Col span={16} className="event-details-text">
            {event.site ? event.site.siteName : ''}
          </Col>
        </Row>
        <Row className="event-details-row">
          <Col span={8} className="event-details-label">
            <FormattedMessage
              id="App.EventDetails.Company"
              defaultMessage="Company"
            />
          </Col>
          <Col span={16} className="event-details-text">
            {event.company ? event.company.companyName : ''}
          </Col>
        </Row>
        <h3>
          <FormattedMessage
            id="App.EventDetails.CoachingStatus"
            defaultMessage="Coaching status"
          />
        </h3>
        {event.coaching &&
          (event.coaching.coachingState === null ||
            event.coaching.coachingState === 'Unqueued' ||
            event.coaching.coachingState === 'AgedOut' ||
            event.coaching.coachingState === 'AgedOutByRetention' ||
            event.coaching.coachingState === 'Dismissed' ||
            event.coaching.coachingState === 'InactiveDriverSwitch') && (
            <div>
              <Row className="event-details-row">
                <Col span={8} className="event-details-label">
                  <FormattedMessage
                    id="App.EventDetails.CoachedOn"
                    defaultMessage="Coached on"
                  />
                </Col>
                <Col span={16} className="event-details-text">
                  {event.coaching.coachingState !== 'Unqueued' && (
                    <FormattedDate
                      value={event.coaching.coachedOn}
                      day="2-digit"
                      month="2-digit"
                      hour="numeric"
                      minute="numeric"
                      timeZoneName="short"
                      timeZone={
                        this.props.ConfigStore.config.standardizedTimezone
                      }
                    />
                  )}
                  {(event.coaching.coachingState === null ||
                    event.coaching.coachingState === 'Unqueued') && (
                    <FormattedMessage
                      id="App.EventDetails.NotCoached"
                      defaultMessage="Not Coached"
                    />
                  )}
                </Col>
              </Row>
            </div>
          )}
        {event.coaching &&
          (event.coaching.coachingState === 'QueuedManually' ||
            event.coaching.coachingState === 'QueuedByCSP' ||
            event.coaching.coachingState === 'Validated') && (
            <div>
              <Row className="event-details-row">
                <Col span={8} className="event-details-label">
                  <FormattedMessage
                    id="App.EventDetails.QueuedOn"
                    defaultMessage="Queued on"
                  />
                </Col>
                <Col span={16} className="event-details-text">
                  <FormattedDate
                    value={event.coaching.queuedOn}
                    day="2-digit"
                    month="2-digit"
                    hour="numeric"
                    minute="numeric"
                    timeZoneName="short"
                    timeZone={
                      this.props.ConfigStore.config.standardizedTimezone
                    }
                  />
                </Col>
              </Row>
              <Row className="event-details-row">
                <Col span={8} className="event-details-label">
                  <FormattedMessage
                    id="App.EventDetails.QueuedBy"
                    defaultMessage="Queued by"
                  />
                </Col>
                <Col span={16} className="event-details-text">
                  {event.coaching.queuedBy}
                </Col>
              </Row>
            </div>
          )}
        {event.coaching &&
          event.coaching.coachingState === 'Coached' && (
            <div>
              <Row className="event-details-row">
                <Col span={8} className="event-details-label">
                  <FormattedMessage
                    id="App.EventDetails.CoachedOn"
                    defaultMessage="Coached on"
                  />
                </Col>
                <Col span={16} className="event-details-text">
                  <FormattedDate
                    value={event.coaching.coachedOn}
                    day="2-digit"
                    month="2-digit"
                    hour="numeric"
                    minute="numeric"
                    timeZoneName="short"
                    timeZone={
                      this.props.ConfigStore.config.standardizedTimezone
                    }
                  />
                </Col>
              </Row>
              <Row className="event-details-row">
                <Col span={8} className="event-details-label">
                  <FormattedMessage
                    id="App.EventDetails.CoachedBy"
                    defaultMessage="Coached by"
                  />
                </Col>
                <Col span={16} className="event-details-text">
                  {event.coaching.coachedBy}
                </Col>
              </Row>
              <Row className="event-details-row">
                <Col span={8} className="event-details-label">
                  <FormattedMessage
                    id="App.EventDetails.Objective"
                    defaultMessage="Objective"
                  />
                </Col>
                <Col span={16} className="event-details-text">
                  {event.coaching.coachingObjective}
                </Col>
              </Row>
              <Row className="event-details-row">
                <Col span={8} className="event-details-label">
                  <FormattedMessage
                    id="App.EventDetails.Outcome"
                    defaultMessage="Outcome"
                  />
                </Col>
                <Col span={16} className="event-details-text">
                  {event.coaching.coachingOutcome}
                </Col>
              </Row>
            </div>
          )}
      </div>
    );
  }
}

export default EventContent;



// WEBPACK FOOTER //
// ./src/containers/EventDetails/EventContent.jsx